import { PropsWithChildren } from 'react'
import Styles from './ToastMessage.module.scss'
import cx from 'classnames'

interface Props {
  clamp?: boolean
  wide?: boolean
}

export const Description = ({ children, clamp = true, wide = false }: PropsWithChildren<Props>) => (
  <div className={Styles.contentContainer}>
    <div className={cx(Styles.content, { [Styles.clamped]: clamp, [Styles.wide]: wide })}>{children}</div>
  </div>
)
